import Modal from './Modal'

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="text-lg font-semibold mb-4">{title}</h2>
      <p className="mb-6">{message}</p>
      <div className="flex justify-end gap-4">
        <button onClick={onClose} className="px-4 py-2 rounded bg-neutral-200">
          Cancel
        </button>
        <button
          onClick={() => {
            onConfirm()
            onClose()
          }}
          className="px-4 py-2 rounded bg-red-600 text-white"
        >
          Confirm
        </button>
      </div>
    </Modal>
  )
}

export default ConfirmModal
